import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {useStore} from "../../../app/stores/rootStore";
export default observer(function CategoryPage() {
const navigate = useNavigate();
const { id } = useParams();
  const { categoryStore,parentCategoryStore,
    userStore:{user,setUser}} = useStore();
    const [categorylist, setParentCategoryList] = useState([]);
    let [parentcategoryname, setParentCategoryName] = useState("");
    
    useEffect(() => {
        if (parentCategoryStore.selectedItem == null)
            navigate("/");
        else {
            if (id) {                
                parentCategoryStore.getItem(id).then(() => {
                    setParentCategoryName(parentCategoryStore.selectedItem.title);
                    categoryStore.loadAll(id).then(() => {
                        setParentCategoryList(categoryStore.items);                        
                    })
                });
            }
        }        
    },[])    
return (
    <>       
    <section data-bs-version="5.1" className="slider6 mbr-embla cid-uATOSlQKYb" id="slider6-i" style={{marginTop:'110px'}}>
    
    <div className="position-relative">
        <div className="mbr-section-head">
            <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2" ><strong>{parentcategoryname}</strong></h4>            
        </div>        
    </div>
</section>
<section data-bs-version="5.1" className="pricing02 healthm5 cid-uAV5l3XCdZ" id="pricing02-k">
    <div className="container-fluid">
        <div className="row">            
            <div className="col-12">
                <div className="items-wrapper">
                {(categoryStore.isLoaded && categorylist != undefined) && categorylist.map((catgory,key) =>(
                    
                    <div className="item features-image">
                        <div className="item-wrapper">
                            <div className="item-img">
                                <div className="image-wrap">
                                    {catgory != null && (catgory.displayMode === "video" ?
                                        <video controls autoPlay={true} loop muted>
                                            <source src={catgory.categoryVideo} type="video/mp4" alt={catgory.title} />
                                            Your browser does not support the video tag.
                                        </video> : <img src={catgory.categoryImage} alt={catgory.title} />)
                                    }                                    
                                </div>
                                <div className="date-wrapper">
                                    <p className="item-date mbr-fonts-style display-7">
                                       
                                    </p>
                                    
                                </div>                                
                            </div>
                            
                            {catgory != null && <div className="item-content">                                                       
                                <h4 className="item-title mbr-fonts-style display-7">
                                <strong>{catgory.title}</strong></h4>                                    
                                <p className="item-text mbr-fonts-style display-4">
                                {catgory.description}
                                </p>
                                <div className="mbr-section-btn"><a className="btn btn-primary-outline display-4" onClick={()=>{
                                    categoryStore.setItem(catgory);                           
                            navigate(`/category/${catgory.id}/products`);
                        }}>Preview</a></div>
                            </div>}
                        </div>
                </div>

))}
</div>                
            </div>
        </div>
    </div>
</section>
    </>
)
})

